<template>
    <v-breadcrumbs
        v-if="path.length"
        :items="path"
    >
        <template #item="{ item: item }">
            <li>
                <a v-if="item.href" :href="item.href" v-text="item.name" :class="item.class"/>
                <span v-else v-text="item.name" :class="item.class"/>
            </li>
        </template>

        <template #divider>
            <span class="neutral-3--text">/</span>
        </template>
    </v-breadcrumbs>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            required: true,
        },
    },
    computed: {
        path() {
            const fromTo = {
                '.create': 'Criar',
                '.edit': 'Editar',
                '.report': 'Relatório',
                '.enable': 'Habilitar',
                '.buy': 'Comprar',
                '.checkout': 'Finalizar compra',
                '.payments': 'Pagamentos',
            };

            const storeItems = this.$store.getters['breadcrumb/get'];
            let items = _.cloneDeep(storeItems.length ? storeItems : this.items);

            return items.map((item, index) => {
                const lastItem = index == (items.length - 1);

                if (!item.name) {
                    const keysFrom = Object.keys(fromTo);
                    const index = keysFrom.findIndex(from => item.route.includes(from));
                    if (index !== -1) item.name = fromTo[keysFrom[index]];
                }

                item.href = lastItem ? '' : this.route(item.route, item.params);
                item.class = lastItem ? 'neutral-3--text' : 'brand-lighten--text';

                return item;
            });
        },
    },
}
</script>

<style scoped lang="scss">
.v-breadcrumbs {
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    font-weight: 500;
    line-height: 140%;

    a {
        text-decoration: none;
    }
}
</style>
